<template lang="pug">
  .row
    loading(v-if="isLoading", :height="200")
    template(v-else)
      app-messages.col-xs-12(:errorMessages="modalErrors")
      .bcard-card-details-card-info-name-office.bcard-card-details-card-info-items(:class="profile.level !== '2' ? 'col-xs-9' : 'col-xs-12'")
        h3.media-heading(v-if="showName") {{profile.full_name}}
        small(v-if="showName") {{profile.full_kana}}
        p(data-testid="-info-office")
          template(v-if="profile.corporate_name")
            | {{profile.corporate_name}}
            br
          template(v-if="profile.dept")
            | {{profile.dept}}
            br
          template(v-if="profile.post")
            | {{profile.post}}
      .col-xs-3.text-center(v-if="profile.level !== '2'")
        template(v-if="Object.keys(profile).length !== 0")
          a.bcard-profile-image(v-if="profile.image_url.length !== 0" href="#" @click.prevent="showUserImageModal")
            img(:src="app_imgsrc.now_loading", v-src:thumbnail="profile.image_url")
          span.bcard-profile-image(v-else)
            img(:src="app_imgsrc.now_loading", v-src:thumbnail="profile.image_url")
      .col-xs-6.bcard-card-details-card-info-items
        .media(v-if="profile.zipcode || profile.address1 || profile.address2")
          .media-left
            i.fa.fa-2x.fa-fw.fa-map-marker(title="住所")
          .media-body.media-middle
            div(v-if="profile.zipcode", data-testid="-zipcode") 〒{{profile.zipcode}}
            div(data-testid="-address") {{profile.address1}} {{profile.address2}}
        .media(v-if="profile.corporate_tel || profile.dept_tel || profile.naisen || profile.hand_tel || profile.fax")
          .media-left
            i.fa.fa-2x.fa-fw.fa-phone(title="電話番号")
          .media-body.media-middle
            dl.dl-horizontal.bcard-card-details-card-info-items
              template(v-if="profile.corporate_tel")
                dt 会社
                dd(data-testid="-corporate-tel") {{profile.corporate_tel}}
              template(v-if="profile.dept_tel")
                dt 部署
                dd(data-testid="-dept-tel") {{profile.dept_tel}}
              template(v-if="profile.naisen")
                dt 内線
                dd(data-testid="-naisen") {{profile.naisen}}
              template(v-if="profile.hand_tel")
                dt 携帯
                dd(data-testid="-hand-tel") {{profile.hand_tel}}
              template(v-if="profile.fax")
                dt FAX
                dd(data-testid="-fax") {{profile.fax}}
      .col-xs-6.bcard-card-details-card-info-items
        .media(v-if="profile.mail")
          .media-left
            i.fa.fa-2x.fa-fw.fa-envelope-o(title="メール")
          .media-body.media-middle
            a(:href="'mailto:'+profile.mail", data-testid="-mail") {{profile.mail}}
        .media(v-if="profile.url")
          .media-left
            i.fa.fa-2x.fa-fw.fa-link(title="URL")
          .media-body.media-middle
            a(:href="profile.valid_url" target="_blank", data-testid="-url") {{profile.url}}

    //- 名刺画像ダイアログ
    modal-images(v-model="modalImages")
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import Loading from '@/components/molecules/Loading'
import ModalImages from '@/components/organisms/ModalImages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const UserRepository = RepositoryFactory.get('user')

export default {
  name: 'ProfileBox',
  components: { AppMessages, Loading, ModalImages },
  props: {
    userId: {type: [Number, String], required: false, default: null},
    showName: {type: Boolean, required: false, default: true},
    topProfile: {type: Object, required: false, default: null},
    isGettingTop: {type: Boolean, required: false, default: null} // TOP API取得中フラグ（true/false/null）
  },
  data: function () {
    return {
      isLoading: true,
      modalErrors: [],
      profile: {},
      // ユーザー画像ダイアログ
      modalImages: {
        isOpen: false,
        sid_user: null
      }
    }
  },
  watch: {
    userId: function (userId) {
      // ユーザーIDが存在する場合
      if (userId !== null) {
        this.getProfile()
      }
    },
    isGettingTop: function (isGettingTop) {
      // 取得完了
      if (isGettingTop === false) {
        this.setProfile()
      }
    }
  },
  created: function () {
    // ユーザーIDが存在する場合
    if (this.userId !== null) {
      // プロフィール情報を取得する
      this.getProfile()
    }

    // TOP APIの取得が完了している場合
    if (this.isGettingTop === false) {
      // プロフィール情報をセットする
      this.setProfile()
    }
  },
  methods: {
    // プロフィール情報取得処理
    getProfile: function () {
      const vm = this
      this.isLoading = true
      this.modalErrors = []
      UserRepository.profile((this.userId || ''))
        .then(function (response) {
          const data = vm.getApiData(response)
          vm.profile = data.data
          vm.isLoading = false
          // vm.$forceUpdate()
        })
        .catch(function (error) {
          if (this.isErrorNotFound(error)) {
            // vm.profile = {}
            // vm.modalErrors = ['ユーザーが見つかりませんでした。']
            // mock用
            vm.profile = {
              'id': 1,
              'image_id': '01k20094169p8y3t',
              'image_url': 'http://example/1',
              'level': '0',
              'full_name': '山田 太郎',
              'full_kana': 'やまだ たろう',
              'corporate_name': 'サンプル会社',
              'corporate_kana': 'さんぷるかいしゃ',
              'dept': 'サンプル部署1',
              'post': 'サンプル役職',
              'mail': 'yamada@example.com',
              'zipcode': '123-4567',
              'address1': '東京都町田市1-2-3',
              'address2': '太田ビル2F',
              'corporate_tel': '0330-88-1590',
              'dept_tel': '0330-88-1595',
              'naisen': '1234',
              'hand_tel': '080-1234-5678',
              'fax': '0330-88-1599',
              'url': 'http://www.rrr-computer.jp',
              'valid_url': 'http://www.rrr-computer.jp',
              'user_state': '0'
            }
          }
          else {
            vm.setErrorMessage(error)
          }
          vm.isLoading = false
        })
    },
    // プロフィール情報をセットする
    setProfile: function () {
      this.profile = this.topProfile
      this.isLoading = false
    },
    // ユーザー画像ダイアログ表示
    showUserImageModal: function () {
      this.modalImages.isOpen = true
      this.modalImages.sid_user = this.userId || this.profile.id
    }
  }
}
</script>

<style lang="scss" scoped>
// プロフィール画像
// .bcard-top .widget-user-2 .widget-user-image > img {
//   height: 65px;
// }
.bcard-profile-image > img,
img.bcard-profile-image {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/ProfileBox.vue